import React from 'react';
import styles from './styles.module.css';

export default ({ text }) => <h2 className={styles.container}>{text}</h2>;



// WEBPACK FOOTER //
// ./src/components/sub-heading/index.js